module.exports = __webpack_public_path__ + "assets/img/huayuan.a0de2915.png";